import { gsap, ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {
  const aboutBlocks = gsap.utils.toArray(".js-about");

  aboutBlocks.forEach((block) => {
    const textBlocks = gsap.utils.toArray(block.querySelectorAll(".js-text-block"));
    const textBlocksContainer = block.querySelector(".js-text-blocks");
    const wrapper = block.querySelector(".js-wrapper");

    function updateTextBlockHeight(currentBlock) {
      if (currentBlock) {
        const blockHeight = currentBlock.offsetHeight;
        textBlocksContainer.style.height = `${blockHeight}px`;
      }
    }

    updateTextBlockHeight(textBlocks[0]);

    textBlocks.forEach((textBlock, index) => {
      const defaultHeight = textBlocks[0].offsetHeight;
      const nextTextBlock = textBlocks[index + 1];
      const isLastTextBlock = index === textBlocks.length - 1;

      textBlocks[0].style.height = `${defaultHeight}px`;

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: block,
          start: 'center center',
          end: 'top bottom-=20%',
          scrub: true,
          onEnter: () => {
            updateTextBlockHeight(textBlock.nextElementSibling);
          },
          onLeaveBack: () => {
            textBlocksContainer.style.height = `${defaultHeight}px`;
          },
        },
      });

      if (!isLastTextBlock) {
        timeline.to(textBlock, {
          opacity: 0,
        });
      }


      if (nextTextBlock) {
        let preTextHeight = textBlock.offsetHeight;
        timeline.fromTo(
          wrapper, {
            y: '0',
          }, {
            y: `-${preTextHeight}px`,
          },
        );

        timeline.fromTo(
          nextTextBlock, {
            opacity: 0,
          }, {
            opacity: 1,
          },
        );
      }
    });
  });
});
